import { Field, Form, Formik, useFormik } from "formik";
import React, { useCallback, useMemo } from "react";
import { useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { AEButton } from "../../../../../_emywork/components/buttons";
import { AESVG } from "../../../../../_emywork/components/svg";
import { localField } from "../../../../../_emywork/helpers/UIHelper";
import { useLang } from "../../../../../_metronic/i18n";
import { formFields } from "../../../../../_metronic/_helpers/forms";
import {
  AEAutoComplete,
  AEInput,
  Select,
} from "../../../../../_metronic/_partials/controls";
import { create } from "../../_redux/crud";
import BankTransfer from "./components/BankTransfer";
import Cash from "./components/Cash";
import Create from "./components/Create";
import PaymentMethod, { PaymentMethods } from "./components/PaymentMethod";
import Voucher from "./components/Voucher";
import { AddFundsSchema } from "./schemas/AddFundsSchemas";

const CoinsForm = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const { formatMessage } = useIntl();
  const [activeStep, setActiveStep] = useState(0);
  // const [isBankTransfer, setIsBankTransfer] = useState(false);
  const [amount, setAmount] = useState(10);
  const { authUser } = useSelector(
    ({ auth }) => ({ authUser: auth.user }),
    shallowEqual
  );

  const initialValues = {
    coins: 10,
    payment_method: "bank_transfer",
    bank: "awb",
    attachments: null,
    user_id: authUser.id,
  };



  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: AddFundsSchema,
    onSubmit: (values) => {
      setLoading(true);
      //TODO: get payment method  from database
      const pMethods = [
        PaymentMethods.bank_transfer,
        PaymentMethods.cash,
        PaymentMethods.voucher,
        // PaymentMethods.paypal,
      ];
      let entity = {
        payment_method_id: pMethods.indexOf(values.payment_method) + 1,
        // bank: values.bank,
        amount: values.coins,
        user_id: authUser.id,
      };

      let files = { attachments: values.attachments };
      create(entity, files)
        .then(() => history.push("/"))
        .finally(() => setLoading(false));
    },
  });

  const {
    handleSubmit,
    getFieldProps,

    values,

    validateForm,
  } = formik;
  const steps = [
    { title: formatMessage({id:"PAYMENT.CREATE"}) },
    { title: formatMessage({id:"PAYMENT.CONFIRM"}) },
  ];
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const stepIsValid = (step) => false;

  const _props = useMemo(() => formFields(formik, getFieldProps), [
    formik,
    getFieldProps,
  ]);

  return (
    <>
      <div className="row">
        {steps.map((row, s) => {
          return (
            <div
              key={s}
              className="col-lg-6 d-flex d-flex align-items-center pr-lg-7 pr-5 gutter-b cursor-pointer"
              // onClick={()=>{setActiveStep(s)}}
            >
              <div className={`symbol symbol-white bg-white`}>
                <span
                  className={`symbol-label font-size-h3 font-weight-boldest text-${
                    activeStep === s ? "primary" : "muted"
                  }`}
                >
                  {stepIsValid(s) ? (
                    <AESVG
                      variant={"primary"}
                      size={"xl"}
                      path={"/Navigation/Check.svg"}
                    />
                  ) : (
                    s + 1
                  )}
                </span>
              </div>
              <div className="font-size-h6 font-weight-bolder mr-3 ml-2">
                {row.title}
              </div>
              {/*{ s < steps.length-1 && <AESVG icon={"/Navigation/Right-2.svg"} /> }*/}
            </div>
          );
        })}
      </div>
      <form action="" onSubmit={handleSubmit}>
        {activeStep === 0 && (
          <Create
            _props={_props}
            coins={values.coins}
            // setIsBankTransfer={setIsBankTransfer}
            paymentMethod={values.payment_method}
          />
        )}
        {activeStep === 1 && (
          <PaymentMethod
            _props={_props}
            bank={values.bank}
            amount={values.coins}
            payment_method={values.payment_method}
          />
        )}

        <div className="form-group d-flex flex-wrap flex-center">
          <Link to="/">
            <AEButton
              variant={"secondary"}
              round={"pill"}
              fontWeight={"bolder"}
              additionalClassName={"font-size-h6 px-8 py-4 my-3 mr-3"}
            >
              {formatMessage({ id: "CANCEL" })}
            </AEButton>
          </Link>
          <AEButton
            variant={"light-info"}
            onClick={handleBack}
            disabled={activeStep === 0}
            fontWeight={"bolder"}
            round={"pill"}
            additionalClassName={"font-size-h6 px-8 py-4 my-3 mr-3"}
          >
            {formatMessage({ id: "BACK" })}
          </AEButton>

          <AEButton
            type={"button"}
            variant={"primary"}
            onClick={(e) => {
              if (activeStep === steps.length - 1) handleSubmit();
              else {
                validateForm().then((r) => {
                  setActiveStep(activeStep + 1);
                });
              }
            }}
            fontWeight={"bolder"}
            round={"pill"}
            additionalClassName={"font-size-h6 px-8 py-4 my-3 mr-3"}
            // disabled={!stepIsValid(activeStep)}
          >
            {formatMessage({
              id: activeStep === steps.length - 1 ? "SUBMIT" : "NEXT",
            })}
            {loading && <span className="ml-3 spinner spinner-white" />}
          </AEButton>
        </div>
      </form>
    </>
  );
};

export default CoinsForm;
